import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { AppInformationService, AuthenticationService, RAFUnitOfWork } from 'src/app/core/core.module';
import { TimeAddDialogComponent } from '../time-add-dialog/time-add-dialog.component';

@Component({
    selector: 'app-time-edit-dialog',
    templateUrl: './time-edit-dialog.component.html',
    styleUrls: ['./time-edit-dialog.component.scss'],
    standalone: false
})
export class TimeEditDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    entities: any;
    filter: any;
    employeeInfos: any;
    employeeId: number;
    employee: any;
    saved = false;
    readOnly = false;
    now: Date;
    timeCategories: any;
    processing = false;
    badge: any;

    constructor(
        public modalRef: BsModalRef,
        private uow: RAFUnitOfWork,
        private appInfo: AppInformationService,
        public auth: AuthenticationService,
        private modalService: BsModalService
    ) {}

    async ngOnInit() {
        const statuses = await this.uow.lookups.statuses;
        await this.getData();
    }

    hasChanges() {
        return this.uow.hasChanges();
    }

    async getData() {
        this.employeeInfos = [];
        if (this.filter.employee) {
            this.employeeInfos = this.filter.employee.split(' ');
        }
        const start = moment(this.filter.date).startOf('day').toDate();
        const end = moment(this.filter.date).startOf('day').toDate();
        this.employeeId = this.employeeInfos[this.employeeInfos.length - 1];
        this.employee = await this.uow.employees.byId(this.employeeId);
        this.timeCategories = await this.uow.getActiveTimeCategories();
        const job = await this.uow.getJobs();
        const items = (await this.uow.getTimeEntriesByEmployeeId(this.employeeId, start, end)) as any;

        if (items.length !== 0) this.entities = items;
    }

    async save(close?: boolean, event?: any) {
        this.appInfo.pleaseWaitShow();
        if (!!event && this.uow.hasChanges()) event.data.edited = new Date();
        await this.uow.commit();
        this.saved = true;
        this.appInfo.pleaseWaitHide();
        if (close) this.result.next({ success: false, refreshData: this.saved });
    }

    async addEntry() {
        const modalRef = this.modalService.show(TimeAddDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                // showAsDialog: true,
                employeeInfos: this.employeeInfos,
                employee: this.employee,
                // badge: this.badge,
                filter: this.filter,
                mode: 'add',
                allowJobSelection: true
            },
        });
        modalRef.content.result.subscribe(async (result) => {
            if (result && result.success) {
                await this.uow.commit();
                this.saved = true;
                await this.getData();
            }
            modalRef.hide();
            this.appInfo.pleaseWaitHide();
        });
    }

    async approve(unApprove?: boolean) {
        this.entities.forEach((x) => {
            x.readyToExport = !unApprove;
            x.approved = unApprove ? null : new Date();
            x.approvedById = unApprove ? null : this.auth.userValue.id;
        });
        await this.save(true);
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false, refreshData: this.saved });
    }

    async deleteRow(e) {
        const time = (await this.uow.timeEntries.byId(e.key)) as any;
        time.deleted = new Date();
        await this.save(true);
    }

    onRowPrepared(e) {
        if (e.rowType === 'data' && !!e.data.edited) {
            e.rowElement.style.backgroundColor = 'yellow';
        }
    }
}
